// // import React, { useState, useEffect } from "react";
// // import { getCategories } from "../../../services/apiService"; // categories API
// // import { setCategoryNews, getCategoryNews } from "../../../services/adminService"; // categoryNews APIs
// // import { Button, Form, Alert, Spinner } from "react-bootstrap";

// // const CategoryNewsForm = () => {
// //   const [categories, setCategories] = useState([]);
// //   const [selectedCategory, setSelectedCategory] = useState("");
// //   const [loading, setLoading] = useState(false);
// //   const [message, setMessage] = useState("");

// //   // ✅ Load categories on mount
// //   useEffect(() => {
// //     const fetchCategories = async () => {
// //       try {
// //         const res = await getCategories();
// //         setCategories(res.data || []);
       
// //       } catch (error) {
// //         console.error("Error loading categories:", error);
// //       }
// //     };
// //     fetchCategories();

// //     // ✅ Load already selected category
// //     const fetchSelectedCategory = async () => {
// //       try {
// //         const res = await getCategoryNews();
// //         if (res.success) {
// //           setSelectedCategory(res.category?._id || "");
// //         }
// //       } catch (error) {
// //         console.warn("No category selected yet");
// //       }
// //     };
// //     fetchSelectedCategory();
// //   }, []);

// //   // ✅ Handle submit
// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     if (!selectedCategory) {
// //       setMessage("Please select a category");
// //       return;
// //     }

// //     setLoading(true);
// //     try {
// //       const res = await setCategoryNews(selectedCategory);
// //       setMessage(res.message || "Category selected successfully!");
// //     } catch (error) {
// //       setMessage(error.response?.data?.message || "Error setting category");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   return (
// //     <div className="p-4 border rounded bg-light shadow-sm">
// //       <h5 className="mb-3">📌 Select Category for News</h5>

// //       {message && <Alert variant="info">{message}</Alert>}

// //       <Form onSubmit={handleSubmit}>
// //         <Form.Group className="mb-3">
// //           <Form.Label>Select Category</Form.Label>
// //           <Form.Select
// //             value={selectedCategory}
// //             onChange={(e) => setSelectedCategory(e.target.value)}
// //           >
// //             <option value="">-- Select --</option>
// //             {categories.map((cat) => (
// //               <option key={cat._id} value={cat._id}>
// //                 {cat.name}
// //               </option>
// //             ))}
// //           </Form.Select>
// //         </Form.Group>

// //         <Button type="submit" variant="primary" disabled={loading}>
// //           {loading ? <Spinner size="sm" animation="border" /> : "Save"}
// //         </Button>

// //         <p></p>
// //       </Form>
// //     </div>
// //   );
// // };

// // export default CategoryNewsForm;

// import React, { useState, useEffect } from "react";
// import { getCategories } from "../../../services/apiService";
// import { setCategoryNews, getCategoryNews } from "../../../services/adminService";
// import { Button, Form, Alert, Spinner } from "react-bootstrap";

// const CategoryNewsForm = () => {
//   const [categories, setCategories] = useState([]);
//   const [selectedCategories, setSelectedCategories] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");

//   // ✅ Load categories + already selected
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const resCats = await getCategories();
//         setCategories(resCats.data || []);

//         const resSelected = await getCategoryNews();
//         if (resSelected.success) {
//           setSelectedCategories(resSelected.categories?.map((c) => c._id) || []);
//         }
//       } catch (error) {
//         console.warn("Error fetching categories or selected categories");
//       }
//     };
//     fetchData();
//   }, []);

//   // ✅ Handle checkbox toggle
//   const handleCheckboxChange = (categoryId) => {
//     setSelectedCategories((prev) =>
//       prev.includes(categoryId)
//         ? prev.filter((id) => id !== categoryId) // remove if already selected
//         : [...prev, categoryId] // add new
//     );
//   };

//   // ✅ Submit
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!selectedCategories.length) {
//       setMessage("Please select at least one category");
//       return;
//     }

//     setLoading(true);
//     try {
//       const res = await setCategoryNews(selectedCategories);
//       setMessage(res.message || "Categories selected successfully!");
//     } catch (error) {
//       setMessage(error.response?.data?.message || "Error setting categories");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="p-4 border rounded bg-light shadow-sm">
//       <h5 className="mb-3">📌 Select Categories for News</h5>

//       {message && <Alert variant="info">{message}</Alert>}

//       <Form onSubmit={handleSubmit}>
//         <Form.Group className="mb-3">
//           <Form.Label>Choose Categories</Form.Label>
//           <div className="d-flex flex-wrap">
//             {categories.map((cat) => (
//               <Form.Check
//                 key={cat._id}
//                 type="checkbox"
//                 id={`cat-${cat._id}`}
//                 label={cat.name}
//                 checked={selectedCategories.includes(cat._id)} // ✅ already selected show checked
//                 onChange={() => handleCheckboxChange(cat._id)}
//                 className="me-3 mb-2"
//               />
//             ))}
//           </div>
//         </Form.Group>

//         <Button type="submit" variant="primary" disabled={loading}>
//           {loading ? <Spinner size="sm" animation="border" /> : "Save"}
//         </Button>
//       </Form>
//     </div>
//   );
// };

// export default CategoryNewsForm;

import React, { useState, useEffect } from "react";
import { getCategories } from "../../../services/apiService";
import { setCategoryNews, getCategoryNews } from "../../../services/adminService";
import { Button, Form, Alert, Spinner, Row, Col } from "react-bootstrap";

const CategoryNewsForm = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  // ✅ Load categories + already selected
  useEffect(() => {
    const fetchData = async () => {
      try {
        const resCats = await getCategories();
        setCategories(resCats.data || []);

        const resSelected = await getCategoryNews();
        if (resSelected.success) {
          setSelectedCategories(resSelected.categories?.map((c) => c._id) || []);
        }
      } catch (error) {
        console.warn("Error fetching categories or selected categories");
      }
    };
    fetchData();
  }, []);

  // ✅ Handle checkbox toggle
  const handleCheckboxChange = (categoryId) => {
    setSelectedCategories((prev) =>
      prev.includes(categoryId)
        ? prev.filter((id) => id !== categoryId) // remove if already selected
        : [...prev, categoryId] // add new
    );
  };

  // ✅ Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedCategories.length) {
      setMessage("Please select at least one category");
      return;
    }

    setLoading(true);
    try {
      const res = await setCategoryNews(selectedCategories);
      setMessage(res.message || "Categories selected successfully!");
    } catch (error) {
      setMessage(error.response?.data?.message || "Error setting categories");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 border rounded bg-light shadow-sm">
      <h5 className="mb-3">📌 Select Categories for News</h5>

      {message && <Alert variant="info">{message}</Alert>}

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label className="fw-bold">Choose Categories</Form.Label>
          <Row>
            {categories.map((cat) => (
              <Col key={cat._id} xs={12} sm={6} md={4} lg={3} className="mb-2">
                <Form.Check
                  type="checkbox"
                  id={`cat-${cat._id}`}
                  label={cat.name}
                  checked={selectedCategories.includes(cat._id)}
                  onChange={() => handleCheckboxChange(cat._id)}
                />
              </Col>
            ))}
          </Row>
        </Form.Group>

        <div className="text-end">
          <Button type="submit" variant="primary" disabled={loading}>
            {loading ? <Spinner size="sm" animation="border" /> : "Save"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default CategoryNewsForm;
